import { Head, Link } from '@inertiajs/react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import { Card } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import type { Breadcrumb } from '@/types/shared'

type TeamSummary = {
  id: string
  name: string
  prefecture?: string | null
  createdAt: string
}

type AdminTeamsIndexProps = {
  teams: TeamSummary[]
  breadcrumbs: Breadcrumb[]
}

export default function AdminTeamsIndex({ teams, breadcrumbs }: AdminTeamsIndexProps) {
  return (
    <AppShell>
      <Head title="チーム一覧" />
      <PageHeader
        title="チーム一覧"
        description="登録済みのチームを管理し、新規登録や編集を行えます。"
        breadcrumbs={breadcrumbs}
        actions={
          <Button asChild size="sm">
            <Link href="/admin/teams/new">新規チーム作成</Link>
          </Button>
        }
      />

      <Card padding="none" className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-white/5 text-sm text-white/80">
            <thead className="bg-white/5 text-xs uppercase tracking-wide text-white/60">
              <tr>
                <th className="px-6 py-4 text-left font-semibold">チーム名</th>
                <th className="px-6 py-4 text-left font-semibold">都道府県</th>
                <th className="px-6 py-4 text-left font-semibold">登録日</th>
                <th className="px-6 py-4" />
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {teams.map((team) => (
                <tr key={team.id} className="hover:bg-white/5 transition">
                  <td className="px-6 py-4 font-medium text-white">{team.name}</td>
                  <td className="px-6 py-4 text-white/70">{team.prefecture ?? '未設定'}</td>
                  <td className="px-6 py-4 text-white/60">{formatDate(team.createdAt)}</td>
                  <td className="px-6 py-4">
                    <div className="flex justify-end gap-4 text-sm">
                      <Link href={`/admin/teams/${team.id}`} className="text-brand-200 hover:text-brand-100">
                        詳細
                      </Link>
                      <Link href={`/admin/teams/${team.id}/edit`} className="text-brand-200 hover:text-brand-100">
                        編集
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {teams.length === 0 ? (
          <div className="px-6 py-16 text-center text-sm text-white/50">登録されているチームはありません。</div>
        ) : null}
      </Card>
    </AppShell>
  )
}

function formatDate(value: string) {
  return new Date(value).toLocaleDateString('ja-JP')
}
